import React, { Component } from 'react';
import Typography from '@mui/material/Typography';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.error("Caught an error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // Use Typography with variant h2 for consistency
            return <Typography variant="h2">Whoops!.</Typography>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
